var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm._t("modal-toggle-btn", null, { toggleClick: _vm.clickToggleTrue }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            width: _vm.width || "640px",
            "custom-class": _vm.customClass,
            visible: _vm.visible,
            "before-close": _vm.handleCancel,
            "append-to-body": _vm.appendToBody || true,
            "close-on-click-modal": false,
            "destroy-on-close": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _vm.visible
            ? _c(
                "div",
                [_vm._t("modal-content", null, { dataState: _vm.dataState })],
                2
              )
            : _vm._e(),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }